import {
  CONFERENCE_ZONE_TYPE_ID,
  ELECTRIC_CHARGING_PLACE_TYPE_ID,
  PARKING_PLACE_TYPE_ID,
  WORKPLACE_PLACE_TYPE_ID
} from "../../../../features/Booking-Form/typings/place-and-zone-type-ids.constant";
import { PlaceType, ZoneType } from "../../../../features/Login/typings/login.types";

/**
 * Place and zone types shown in capacity report filters / toggles.
 * Order is fixed by priority: workplace (when enabled), conference zone, then parking / electric.
 * Workplace is included only when `workplaceBookingEnabled` is true.
 */
export function buildCapacityReportAvailableTypes(
  placeTypes: PlaceType[],
  zoneTypes: ZoneType[],
  workplaceBookingEnabled: boolean | undefined
): Array<PlaceType | ZoneType> {
  const workplaceEntries = placeTypes.filter(
    typ => typ.id === WORKPLACE_PLACE_TYPE_ID && Boolean(workplaceBookingEnabled)
  );
  const conferenceZoneEntries = zoneTypes.filter(typ => typ.id === CONFERENCE_ZONE_TYPE_ID);
  const otherPlaceEntries = placeTypes.filter(
    typ => typ.id === PARKING_PLACE_TYPE_ID || typ.id === ELECTRIC_CHARGING_PLACE_TYPE_ID
  );

  return [...workplaceEntries, ...conferenceZoneEntries, ...otherPlaceEntries];
}
